import React, { useEffect } from 'react';
import { Card, Col, Row, Typography, Statistic, Button, Divider, Icon } from 'antd';
import { UserAddOutlined, FileAddOutlined, DesktopOutlined, BarChartOutlined, UserOutlined, ClockCircleOutlined, GlobalOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import PageVisits from './PageVisits';
import { fetchUsers } from '../../actions/UserActions';
import dayjs from "dayjs";
import { Link } from 'react-router-dom';

const { Title } = Typography;


const Dashboard = () => {
  const dispatch = useDispatch();

  const { requests, loading, error } = useSelector(state => state.talentSearch);
  const { artists } = useSelector(state => state.artists);
  const { users } = useSelector((state) => state.user);
  const allVisits = useSelector((state) => state.analytics.visits);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);


   useEffect(() => {
          window.scrollTo(0, 0);
      }, []);

  // const getUniqueVisitsToday = () => {
  //   const todayStart = dayjs().startOf("day").valueOf(); // Start of today in milliseconds

  //   return Array.from(
  //     allVisits
  //       .filter((visit) => dayjs(visit.time).isAfter(todayStart)) // Filter today's visits
  //       .reduce((map, visit) => map.set(visit.deviceId, visit), new Map()) // Keep unique deviceId visits
  //       .values() // Extract unique visits
  //   );
  // };

  const getUniqueVisitsToday = () => {
    const todayStart = dayjs().startOf("day"); // Ensure start of today is consistent
  
    return Array.from(
      allVisits
        .filter((visit) => visit.deviceId && dayjs(visit.time).isAfter(todayStart)) // Ensure valid deviceId
        .reduce((set, visit) => set.add(visit.deviceId), new Set()) // Track unique deviceIds
    );
  };
  

  const uniqueVisits = getUniqueVisitsToday();

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5' }}>
      {/* <Title level={2} style={{ color: '#059941', textAlign: 'center' }}>
        Sanecka Brand Dashboard
      </Title> */}

      {/* Overview Stats */}
      <Row gutter={16} justify="space-between" >
        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }} >
          <Card
            bordered={false}
            style={{ textAlign: 'center', borderRadius: '8px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}
          >
            <Statistic
              title="Artists Registered"
              value={artists?.length}
              prefix={<UserOutlined />}
              style={{ fontSize: '24px' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }}  >
          <Card
            bordered={false}
            style={{ textAlign: 'center', borderRadius: '8px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}
          >
            <Statistic
              title="New Requests"
              value={requests?.filter((req) => req.status === 'new')?.length}
              prefix={<FileAddOutlined />}
              style={{ fontSize: '24px' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }} >
          <Card
            bordered={false}
            style={{ textAlign: 'center', borderRadius: '8px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}
          >
            <Statistic
              title="Visitors Today"
              value={uniqueVisits?.length}
              prefix={<BarChartOutlined />}
              style={{ fontSize: '24px' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }} >
          <Card
            bordered={false}
            style={{ textAlign: 'center', borderRadius: '8px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}
          >
            <Statistic
              title="Total Users"
              value={users?.length}
              prefix={<UserOutlined />}
              style={{ fontSize: '24px' }}
            />
          </Card>
        </Col>
      </Row>

      {/* Recent Requests */}
      <Row >
        <Col span={24}>
          <Title level={4} style={{ color: '#2f3589' }}>
            Page Visits
          </Title>
          <Divider />
        </Col>
        <Col span={24}>

          <PageVisits />
        </Col>
      </Row>

      {/* Recent Requests */}
      <Row gutter={16} justify="space-between">
        <Col span={24}>
          <Title level={4} style={{ color: '#2f3589' }}>
            Recent Requests
          </Title>
          <Divider />
        </Col>

        {/* Display Recent Requests */}
        {requests?.sort((a, b) => b.time - a.time).slice(0, 3).map((request) => (
          <Col
            xs={24}
            sm={requests.slice(0, 3).length === 1 ? 24 : 12}
            md={
              requests.slice(0, 3).length === 3
                ? 8
                : requests.slice(0, 3).length === 2
                  ? 12
                  : 24
            }
            style={{ marginBottom: '30px' }}
            key={request.id}>
            <Card
              title={request.artistName}
              bordered={false}
              extra={<span>{request.status?.charAt(0).toUpperCase() + request.status?.slice(1)}</span>}
              style={{
                borderRadius: '8px',
                boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
              }}
            >
              <p><UserOutlined /> Address: {request.city}</p>
              <p><GlobalOutlined /> Nationality: {request.nationality}</p>
              <p><ClockCircleOutlined /> Submission date: {dayjs(request.time).format('DD-MMM-YYYY')}</p>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Quick Links */}
      <Row gutter={16} justify="space-evenly" style={{ marginTop: '40px', marginBottom: '40px' }}>
        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }}>
          <Card
            bordered={false}
            style={{
              textAlign: 'center',
              borderRadius: '8px',
              boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
              backgroundColor: '#059941',
              color: 'white',
            }}
          >
            
            <Link  style={{ color: 'white', fontSize: '18px' }} to="/artists">
              Manage Artists
            </Link>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }}>
          <Card
            bordered={false}
            style={{
              textAlign: 'center',
              borderRadius: '8px',
              boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
              backgroundColor: '#2f3589',
              color: 'white',
            }}
          >
            <Link  style={{ color: 'white', fontSize: '18px' }} to="/requests">
              Talent Requests
            </Link>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }}>
          <Card
            bordered={false}
            style={{
              textAlign: 'center',
              borderRadius: '8px',
              boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
              backgroundColor: '#059941',
              color: 'white',
            }}
          >
            <Link style={{ color: 'white', fontSize: '18px' }} to="/visits">
              Visits
            </Link>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6} style={{ marginBottom: '30px' }}>
          <Card
            bordered={false}
            style={{
              textAlign: 'center',
              borderRadius: '8px',
              boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
              backgroundColor: '#2f3589',
              color: 'white',
            }}
          >
            <Link style={{ color: 'white', fontSize: '18px' }} to="/master-codes">
              Master Codes
            </Link>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
